import LockOpen from './src/lock-open-combined';
export default LockOpen;